import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HubConnectionManager } from '../../../../supplier-portal/shared/services/src/lib/hubs/hub-connection-manager.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [HubConnectionManager],
})
export class HubsModule {}
